export async function scrollActiveContentToTop(duration = 300) {
    const el = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2) as HTMLElement | null
    if (!el) return

    const ionContent = el.closest("ion-content") as HTMLIonContentElement | null
    if (ionContent) {
        await ionContent.scrollToTop(duration)
    }
}

let isScrollHandlerAttached = false

export function initScrollToTopContent() {
    if (isScrollHandlerAttached) return

    window.addEventListener("statusTap", () => {
        scrollActiveContentToTop()
    })

    isScrollHandlerAttached = true
}
